import axios from '../../utils/axiosConfig';
import { authRefreshed } from './auth';

// Action Types
export const GET_BRAND_REQUEST = 'GET_BRAND_REQUEST';
export const GET_BRAND_SUCCESS = 'GET_BRAND_SUCCESS';
export const GET_BRAND_FAIL = 'GET_BRAND_FAIL';

export const LIST_BRANDS_REQUEST = 'LIST_BRANDS_REQUEST';
export const LIST_BRANDS_SUCCESS = 'LIST_BRANDS_SUCCESS';
export const LIST_BRANDS_FAIL = 'LIST_BRANDS_FAIL';

export const SEARCH_BRANDS_REQUEST = 'SEARCH_BRANDS_REQUEST';
export const SEARCH_BRANDS_SUCCESS = 'SEARCH_BRANDS_SUCCESS';
export const SEARCH_BRANDS_FAIL = 'SEARCH_BRANDS_FAIL';

export const UPDATE_BRAND_PROFILE_REQUEST = 'UPDATE_BRAND_PROFILE_REQUEST';
export const UPDATE_BRAND_PROFILE_SUCCESS = 'UPDATE_BRAND_PROFILE_SUCCESS';
export const UPDATE_BRAND_PROFILE_FAIL = 'UPDATE_BRAND_PROFILE_FAIL';

export const LIST_BRAND_PAID_EVENTS_REQUEST = 'LIST_BRAND_PAID_EVENTS_REQUEST';
export const LIST_BRAND_PAID_EVENTS_SUCCESS = 'LIST_BRAND_PAID_EVENTS_SUCCESS';
export const LIST_BRAND_PAID_EVENTS_FAIL = 'LIST_BRAND_PAID_EVENTS_FAIL';

export const GET_BILLING_DETAILS_REQUEST = 'GET_BILLING_DETAILS_REQUEST';
export const GET_BILLING_DETAILS_SUCCESS = 'GET_BILLING_DETAILS_SUCCESS';
export const GET_BILLING_DETAILS_FAIL = 'GET_BILLING_DETAILS_FAIL';

export const SAVE_BILLING_DETAILS_REQUEST = 'SAVE_BILLING_DETAILS_REQUEST';
export const SAVE_BILLING_DETAILS_SUCCESS = 'SAVE_BILLING_DETAILS_SUCCESS';
export const SAVE_BILLING_DETAILS_FAIL = 'SAVE_BILLING_DETAILS_FAIL';

export const getBrand = (brandId, { lang } = {}) => async (dispatch, getState) => {
  dispatch({ type: GET_BRAND_REQUEST });
  const { auth } = getState();
  const token = auth.token;
  try {
    const params = new URLSearchParams();
    if (lang) params.set('lang', lang);
    const qs = params.toString();
    const res = await axios.get(`/brands/profile/${brandId}${qs ? `?${qs}` : ''}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: GET_BRAND_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_BRAND_FAIL,
      payload: err.response?.data?.message || 'Failed to fetch brand',
    });
  }
};

export const getBrandBySlug = (brandSlug, { lang } = {}) => async (dispatch, getState) => {
  dispatch({ type: GET_BRAND_REQUEST });
  const { auth } = getState();
  const token = auth.token;
  try {
    const params = new URLSearchParams();
    if (lang) params.set('lang', lang);
    const qs = params.toString();
    const res = await axios.get(`/brands/by-slug/${brandSlug}${qs ? `?${qs}` : ''}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({
      type: GET_BRAND_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_BRAND_FAIL,
      payload: err.response?.data?.message || 'Failed to fetch brand',
    });
  }
};

export const listBrands =
  ({ page = 1, pageSize = 12, sort, sortBy, sortOrder, append = false, lang } = {}) =>
  async (dispatch, getState) => {
    dispatch({ type: LIST_BRANDS_REQUEST, meta: { append } });
    const { auth } = getState();
    const token = auth.token;

    const params = new URLSearchParams();
    params.set('page', page);
    params.set('pageSize', pageSize);
    if (sort) params.set('sort', sort);
    if (sortBy) params.set('sortBy', sortBy);
    if (sortOrder) params.set('sortOrder', sortOrder);
    if (lang) params.set('lang', lang);

    try {
      const res = await axios.get(`/brands/all?${params.toString()}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });

      const payload =
        res.data && Array.isArray(res.data)
          ? { data: res.data, pagination: null, append }
          : {
              data: res.data?.data ?? [],
              pagination: res.data?.pagination ?? null,
              append,
            };

      dispatch({ type: LIST_BRANDS_SUCCESS, payload });
      return res.data;
    } catch (err) {
      dispatch({
        type: LIST_BRANDS_FAIL,
        payload: err.response?.data?.message || 'Failed to fetch brands',
      });
    }
  };

export const searchBrands =
  (
    filters = {},
    { page = 1, pageSize = 12, sort, sortBy, sortOrder, append = false, lang } = {}
  ) =>
  async (dispatch) => {
    dispatch({ type: SEARCH_BRANDS_REQUEST, meta: { append } });
    const params = new URLSearchParams();
    // filters
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        if (value.length) params.append(key, value.join(','));
      } else if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    // pagination/sort
    params.set('page', page);
    params.set('pageSize', pageSize);
    if (sort) params.set('sort', sort);
    if (sortBy) params.set('sortBy', sortBy);
    if (sortOrder) params.set('sortOrder', sortOrder);
    if (lang) params.set('lang', lang);

    try {
      const res = await axios.get(`/brands/search?${params.toString()}`);
      // Support new {data,pagination} and old []
      const payload =
        res.data && Array.isArray(res.data)
          ? { data: res.data, pagination: null, append }
          : {
              data: res.data?.data ?? [],
              pagination: res.data?.pagination ?? null,
              append,
            };

      dispatch({ type: SEARCH_BRANDS_SUCCESS, payload });
      return res.data;
    } catch (err) {
      dispatch({
        type: SEARCH_BRANDS_FAIL,
        payload: err.response?.data?.message || 'Failed to search brands',
      });
    }
  };

export const updateBrandProfile =
  (brandId, formData) => async (dispatch, getState) => {
    dispatch({ type: UPDATE_BRAND_PROFILE_REQUEST });
    const { auth } = getState();
    const token = auth.token;

    try {
      const res = await axios.put(`/brands/profile/${brandId}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      dispatch({
        type: UPDATE_BRAND_PROFILE_SUCCESS,
        payload: res.data,
      });

      const current = auth?.user || {};
      const bust = Date.now();
      const mergedUser = {
        ...current,
        ...(res.data.avatar
          ? { avatar: res.data.avatar, avatarUpdatedAt: bust }
          : {}),
        ...(res.data.username ? { username: res.data.username } : {}),
      };
      dispatch(authRefreshed({ token, user: mergedUser }));

      return res.data;
    } catch (err) {
      dispatch({
        type: UPDATE_BRAND_PROFILE_FAIL,
        payload:
          err.response?.data?.message || 'Failed to update brand profile',
      });
      throw err;
    }
  };

/**
 * The brand's saved invoicing identity ({ name, nif, address, contact }).
 * It never rides along on the brand profile payload — that endpoint is public —
 * so it lives on its own authenticated own-account route and its own slice of
 * state, separate from `brands.brand` (which may hold *another* brand's
 * profile while browsing).
 */
export const fetchBrandBillingDetails =
  ({ force = false } = {}) =>
  async (dispatch, getState) => {
    const { brands } = getState();
    if (!force && (brands.billingDetailsLoaded || brands.billingDetailsLoading)) {
      return brands.billingDetails;
    }

    dispatch({ type: GET_BILLING_DETAILS_REQUEST });
    try {
      const res = await axios.get('/brands/me/billing-details');
      const billingDetails = res.data?.billingDetails ?? null;
      dispatch({ type: GET_BILLING_DETAILS_SUCCESS, payload: billingDetails });
      return billingDetails;
    } catch (err) {
      dispatch({
        type: GET_BILLING_DETAILS_FAIL,
        payload:
          err.response?.data?.message || 'Failed to fetch billing details',
      });
      return null;
    }
  };

export const saveBrandBillingDetails =
  (billingDetails) => async (dispatch) => {
    dispatch({ type: SAVE_BILLING_DETAILS_REQUEST });
    try {
      const res = await axios.put('/brands/me/billing-details', {
        billingDetails,
      });
      const saved = res.data?.billingDetails ?? null;
      dispatch({ type: SAVE_BILLING_DETAILS_SUCCESS, payload: saved });
      return saved;
    } catch (err) {
      dispatch({
        type: SAVE_BILLING_DETAILS_FAIL,
        payload:
          err.response?.data?.message || 'Failed to save billing details',
      });
      throw err;
    }
  };

export const listBrandPaidEvents = (brandId) => async (dispatch, getState) => {
  dispatch({ type: LIST_BRAND_PAID_EVENTS_REQUEST });
  const { auth } = getState();
  const token = auth.token;

  try {
    const res = await axios.get(`/brands/${brandId}/paid-events`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch({ type: LIST_BRAND_PAID_EVENTS_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    dispatch({
      type: LIST_BRAND_PAID_EVENTS_FAIL,
      payload: err.response?.data?.message || 'Failed to fetch paid events',
    });
    throw err;
  }
};
